export default "__VITE_ASSET__6e66e613__"